import React from 'react';
import PropTypes from 'prop-types';
import {
  NotificationContainer,
  NotificationContent,
  NotificationText,
  NotificationHeader,
  NotificationCloseIcon,
  NotificationBody,
} from './ToastDisplay.styles';

import { StyledAvatar } from '../../StyledAvatar/StyledAvatar';
import { useSelector } from 'react-redux';

export const ToastDisplay = ({ title = '', body = '', onClose }) => {
  const currentUser = useSelector((state) => state.currentUser);

  return (
    <NotificationContainer>
      <NotificationContent>
        <StyledAvatar
          size="xsmall"
          alt={currentUser?.employeeInfo?.displayName || 'User'}
          src={currentUser?.employeeInfo?.profileImageUrl}
        />
        <NotificationText>
          <NotificationHeader variant="title6">{title}</NotificationHeader>
          <NotificationBody variant="subtitle2">{body}</NotificationBody>
        </NotificationText>
      </NotificationContent>
      <NotificationCloseIcon onClick={() => onClose()} />
    </NotificationContainer>
  );
};
ToastDisplay.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  onClose: PropTypes.func,
};
export default ToastDisplay;
